import axios from "axios";
import cleanDeep from "clean-deep";
import { checkExecutionStatus, createRequest } from "@/components/common/helpers/RequestHelpers";
import { NotificationManager } from "react-notifications";
import apiURL from "./apiURL";

const settingsRequest = createRequest({
	urlPath: "/settings",
	// local: true,
});
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];
// types of action
const Types = {
	FSSREPORT_UPDATING: "FSSREPORT_UPDATING",
	FSSREPORT_UPDATE: "FSSREPORT_UPDATE",
	FSSREPORT_DOWNLOADING: "FSSREPORT_DOWNLOADING",
	FSSREPORT_FS3_IN_PORTAL: "FSSREPORT_FS3_IN_PORTAL",
	FSSREPORT_V2_REPORTS: "FSSREPORT_V2_REPORTS",
	FSSREPORT_REGENERATE_MODAL: "FSSREPORT_REGENERATE_MODAL",
	FSSREPORT_REGENERATING: "FSSREPORT_REGENERATING",
	FSSREPORT_OPEN_EID_MODAL: "FSSREPORT_OPEN_EID_MODAL",
	FSSREPORT_LOADING_EID_CREDENTIALS: "FSSREPORT_LOADING_EID_CREDENTIALS",
	FSSREPORT_SAVED_EID_CREDENTIALS: "FSSREPORT_SAVED_EID_CREDENTIALS",
	FSSREPORT_SELECT_FORM: "FSSREPORT_SELECT_FORM",
	FSSREPORT_OPEN_VALIDATION_MODAL: "FSSREPORT_OPEN_VALIDATION_MODAL",
	FSSREPORT_LOADING_FS7_VALIDATION: "FSSREPORT_LOADING_FS7_VALIDATION",
	FSSREPORT_VALIDATION_RESULT: "FSSREPORT_VALIDATION_RESULT",
	FSSREPORT_FORM_DOWNLOAD_STATUS: "FSSREPORT_FORM_DOWNLOAD_STATUS",
	FSSREPORT_LOGIN_ERROR: "FSSREPORT_LOGIN_ERROR",
	FSSREPORT_ORGANISATIONS: "FSSREPORT_ORGANISATIONS",
	FSSREPORT_SELECTED_COMPANIES: "FSSREPORT_SELECTED_COMPANIES",
	FSSREPORT_EXPRESS_COMPANY: "FSSREPORT_EXPRESS_COMPANY",
	FSSREPORT_CIS_MODAL: "FSSREPORT_CIS_MODAL",
	FSSREPORT_SAVING_CIS_DEDUCTIONS: "FSSREPORT_SAVING_CIS_DEDUCTIONS",
	FSSREPORT_OPEN_TAX_FORM_IMPORT_MODAL: "FSSREPORT_OPEN_TAX_FORM_IMPORT_MODAL",
	FSSREPORT_PROCESSING_IMPORT: "FSSREPORT_PROCESSING_IMPORT",
	FSSREPORT_IMPORT_RESULT: "FSSREPORT_IMPORT_RESULT",
	FSSREPORT_UPDATE_SINGLE: "FSSREPORT_UPDATE_SINGLE",
};

const toggleV2TaxReports = () => ({
	type: Types.FSSREPORT_V2_REPORTS,
});

const openTaxFormImportModal = (status) => ({
	type: Types.FSSREPORT_OPEN_TAX_FORM_IMPORT_MODAL,
	status,
});

const processingImport = (status) => ({
	type: Types.FSSREPORT_PROCESSING_IMPORT,
	status,
});

const importResult = (response) => ({
	type: Types.FSSREPORT_IMPORT_RESULT,
	response,
});

const clearImportResults = () => ({
	type: Types.FSSREPORT_IMPORT_RESULT,
	response: undefined,
});

const uploadTaxForm = (type) => {
	return async (dispatch, getState) => {
		const state = getState();

		const filesUploaded = state.employees.filesUploaded;

		dispatch(processingImport(true));

		await settingsRequest({
			method: "POST",
			path: `/sf/${type}`,
			body: {
				key: filesUploaded[filesUploaded.length - 1].key,
			},
		})
			.then(async ({ data }) => {
				await checkExecutionStatus(data.executionArn)
					.then(({ output }) => {
						dispatch(importResult(output));
					})
					.catch((err) => {
						console.error(err);
						NotificationManager.error("Error Uploading Tax Form", "Upload Tax Form");
					});
				dispatch(processingImport(false));
			})
			.catch((err) => {
				console.error(err);
				NotificationManager.error("Error Uploading Tax Form", "Upload Tax Form");
				dispatch(processingImport(false));
			});
	};
};

const selectSubmissionForm = (year, form) => ({
	type: Types.FSSREPORT_SELECT_FORM,
	year,
	form,
});

const updateSelectedCompanies = (checked, peNumber, clear) => ({
	type: Types.FSSREPORT_SELECTED_COMPANIES,
	checked,
	peNumber,
	clear,
});
const fssOrganisations = (payload) => ({
	type: Types.FSSREPORT_ORGANISATIONS,
	payload: payload.companies,
});
const setFSSExpressCompany = (peNumber, payload) => ({
	type: Types.FSSREPORT_EXPRESS_COMPANY,
	peNumber,
	payload,
});
const fssReportingUpdating = (status) => ({
	type: Types.FSSREPORT_UPDATING,
	status,
});
const validationResult = (response) => ({
	type: Types.FSSREPORT_VALIDATION_RESULT,
	response,
});
const openEIDModal = (status) => ({
	type: Types.FSSREPORT_OPEN_EID_MODAL,
	status,
});
const setLoginError = ({ error }) => ({
	type: Types.FSSREPORT_LOGIN_ERROR,
	error,
});
const openFS7ValidationModal = (status, errors) => ({
	type: Types.FSSREPORT_OPEN_VALIDATION_MODAL,
	status,
	errors,
});
const loadingValidation = (status, submit) => ({
	type: Types.FSSREPORT_LOADING_FS7_VALIDATION,
	status,
	submit,
});
const loadingCredentials = (status) => ({
	type: Types.FSSREPORT_LOADING_EID_CREDENTIALS,
	status,
});
const saveCredentials = (status, response) => ({
	type: Types.FSSREPORT_SAVED_EID_CREDENTIALS,
	status,
	response,
});

const fssReportingUpdated = (response) => ({
	type: Types.FSSREPORT_UPDATE,
	payload: response,
});

const fssReportingUpdateSingle = (response) => ({
	type: Types.FSSREPORT_UPDATE_SINGLE,
	payload: response,
});

const listFssReports = (body) => {
	return async (dispatch, getState) => {
		const state = getState();

		if (state.showV2Reports) {
			body.v2 = true;
		}
		// const v2String = state.showV2Reports ? `?v2=true` : ``

		dispatch(fssReportingUpdating(true));
		await fetch(apiURL + `/settings/taxReports`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(body),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);
				dispatch(fssReportingUpdated(data));
			})
			.catch((e) => {
				// error none found likely only exist in v2...
				dispatch(fssReportingUpdated([]));
			});
		setTimeout(() => dispatch(fssReportingUpdating(false)), 1000);
	};
};

const downloadReportStatus = (index, processing) => ({
	type: Types.FSSREPORT_DOWNLOADING,
	index,
	processing,
});

const downloadFSSReport = (body) => {
	return (dispatch, getState) => {
		dispatch(downloadReportStatus(body?.name, true));
		// if (body.employee == 'all'){
		//   fetch(apiURL + `/pdf/fs3/${body.year}` , {
		//       credentials: 'include',
		//       method: 'GET',
		//       // body: JSON.stringify(body),
		//       headers: {
		//         'Accept': 'application/json',
		//         'Content-Type': 'application/json',
		//         /*'Organisation': getState().currentOrganisation,*/
		//       },
		//   })
		//   .then(response => response.json())
		//   .then(data => {

		//     const popup = window.open(data.signedURL);
		//     if (!popup || popup.closed || typeof popup.closed=='undefined'){
		//           //Worked For IE and Firefox
		//           alert("Popup Blocker is enabled! Please add this site to your exception list.");
		//     }

		//     dispatch(downloadReportStatus(body.index,false))
		//   })
		// } else {

		settingsRequest({
			method: "POST",
			path: `/taxReport`,
			body,
			org: body.org,
		}).then(({ data }) => {
			const popup = window.open(data.url);
			if (!popup || popup.closed || typeof popup.closed == "undefined") {
				//Worked For IE and Firefox
				alert("Popup Blocker is enabled! Please add this site to your exception list.");
			}

			dispatch(downloadReportStatus(body.name, false));
		});
	};
	// }
};

const openRegenerateFormsModal = ({ status, year, reportType }) => ({
	type: Types.FSSREPORT_REGENERATE_MODAL,
	status,
	year,
	reportType,
});

const openCISModal = (report) => ({
	type: Types.FSSREPORT_CIS_MODAL,
	report,
});

const regeneratingReportStatus = (status) => ({
	type: Types.FSSREPORT_REGENERATING,
	status,
});

const checkReportGenerationStatus = (arn) => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/describe-execution/${arn}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				const finished = data.data.status !== "RUNNING";

				if (finished) {
					if (data.data.status === "SUCCEEDED") {
						NotificationManager.success(
							"The FS3s and FS7 have been successfully regenerated",
							"Regenerate FS3s & FS7",
						);
						const state = getState();
						dispatch(
							listFssReports({
								name: state.fssRegenerateModal.reportType,
								year: state.fssRegenerateModal.year,
							}),
						);
						dispatch(regeneratingReportStatus(false));
						dispatch(openRegenerateFormsModal({ status: false }));
					} else {
						NotificationManager.error("We encountered an issue in regenerating your reports.", "Error");
						dispatch(regeneratingReportStatus(false));
						dispatch(openRegenerateFormsModal({ status: false }));
					}
				} else {
					setTimeout(() => dispatch(checkReportGenerationStatus(arn)), 1000);
				}
			});
	};
};

const regenerateFSSReports = ({ year }) => {
	return (dispatch, getState) => {
		dispatch(regeneratingReportStatus(true));

		fetch(apiURL + `/settings/regenerate-tax-forms`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ year }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.url && !data.error) {
					let popup;
					popup = window.open(data.url);
					if (!popup || popup.closed || typeof popup.closed == "undefined") {
						alert("Popup Blocker is enabled! Please add this site to your exception list.");
					}
				} else if (data.executionArn) {
					const arn = data.executionArn;

					setTimeout(() => dispatch(checkReportGenerationStatus(arn)), 1000);
				} else {
					NotificationManager.error("We encountered an issue in regenerating your reports.", "Error");
					dispatch(regeneratingReportStatus(false));
					dispatch(openRegenerateFormsModal({ status: false }));
				}
			})
			.catch((e) => {
				console.error(e);
				dispatch(regeneratingReportStatus(false));
				dispatch(openRegenerateFormsModal({ status: false }));
			});
	};
};

const downloadingFormStatus = (form, status) => ({
	type: Types.FSSREPORT_FORM_DOWNLOAD_STATUS,
	form,
	status,
});

const downloadEmployeeForm = (params) => {
	return (dispatch, getState) => {
		const { form } = params;

		dispatch(downloadingFormStatus(form, true));
		fetch(apiURL + `/settings/pdf/${form}`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(cleanDeep({ ...params, form: undefined })),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				const arn = data.executionArn;

				setTimeout(() => dispatch(checkEmployeeFormGeneration(arn, form)), 1000);
			});
	};
};

const checkEmployeeFormGeneration = (arn, form) => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/describe-execution/${arn}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				const finished = data.data.status !== "RUNNING";

				if (finished) {
					if (data.data.status === "SUCCEEDED") {
						const popup = window.open(JSON.parse(data.data.output).url);
						if (!popup || popup.closed || typeof popup.closed == "undefined") {
							//Worked For IE and Firefox
							alert("Popup Blocker is enabled! Please add this site to your exception list.");
						}
					} else {
						NotificationManager.error(`We encountered an issue in generating the ${form}.`, "Error");
					}
					dispatch(downloadingFormStatus(form));
				} else {
					setTimeout(() => dispatch(checkEmployeeFormGeneration(arn, form)), 1000);
				}
			});
	};
};

const fs3InPortalUpdated = (response) => ({
	type: Types.FSSREPORT_FS3_IN_PORTAL,
	response,
});

const showF3InPortal = (body) => {
	return (dispatch, getState) => {
		dispatch(downloadReportStatus(body && body.index, true));
		fetch(apiURL + `/settings/showFS3InPortal`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(body),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(fs3InPortalUpdated(body));
			});
	};
};

const logInToEID = async ({ username, password, year, peNumber, org }) => {
	return await axios({
		method: "POST",
		url: apiURL + `/fss/auth`,
		withCredentials: true,
		data: JSON.stringify({ username, password, year, peNumber, org }),
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			/*'Organisation': getState().currentOrganisation,*/
		},
	});
};

const verifyEIDCredentials = ({ id, password, peNumber, year }, forBulkSubmission) => {
	return async (dispatch, getState) => {
		const username = id;

		if (forBulkSubmission) {
			const state = getState();

			const selectedOrganisations = state.fssExpress?.selectedOrganisations;

			if (!peNumber && Array.isArray(selectedOrganisations)) {
				dispatch(openEIDModal());

				await Promise.all(
					selectedOrganisations.map(async ({ peNumber, status, organisations: org }) => {
						const originalStatus = status;
						dispatch(
							setFSSExpressCompany(peNumber, {
								status: "Signing In",
							}),
						);
						logInToEID({ username, password, year, peNumber, org })
							.then((response) => {
								dispatch(saveCredentials({ username, password }, { year }));
								dispatch(
									setFSSExpressCompany(peNumber, {
										error: undefined,
										status: "Authenticated",
										authenticated: true,
									}),
								);
							})
							.catch((error) => {
								dispatch(
									setFSSExpressCompany(peNumber, {
										error: "Failed to Authenticate",
										status: undefined,
									}),
								);
							});
					}),
				);

				return;
			}
		} else {
			dispatch(loadingCredentials(true));

			logInToEID({ username, password, year, peNumber })
				.then((response) => {
					dispatch(saveCredentials({ username, password, peNumber, year }, response.data));
					dispatch(openEIDModal());
					NotificationManager.success("Logged In Successfully!", "Logging In With E-ID");
				})
				.catch((error) => {
					console.error(error);
					NotificationManager.error(error.response.data.message, "Logging In With E-ID");
					dispatch(setLoginError({ year, error: error.response.data.message }));
				});
			dispatch(loadingCredentials());
		}
	};
};

const validateTaxForm = ({ year, form, credentials, test, peNumber, organisations }) => {
	return axios({
		method: "POST",
		url: apiURL + `/fss/${year}`,
		withCredentials: true,
		data: JSON.stringify({ ...credentials, test, peNumber, organisations }),
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			/*'Organisation': getState().currentOrganisation,*/
		},
	});
};

const validateFS7 = ({ year, submit, peNumber }) => {
	return async (dispatch, getState) => {
		if (!peNumber) dispatch(openFS7ValidationModal(true));
		dispatch(loadingValidation(true, submit));

		const state = getState();

		const action = submit ? "Submit" : "Validate";
		const continuous = submit ? "Submitting" : "Validating";
		const past = submit ? "Submitted" : "Validated";
		const form = "fs7";

		const selectedOrganisations = state.fssExpress?.selectedOrganisations;
		const credentials = state.submissionForm?.credentials;

		if (!peNumber && Array.isArray(selectedOrganisations)) {
			await Promise.all(
				selectedOrganisations.map(async ({ peNumber, status, organisations }) => {
					const originalStatus = status;
					dispatch(
						setFSSExpressCompany(peNumber, {
							status: continuous,
						}),
					);
					await validateTaxForm({ year, form: "fs7", credentials, test: !submit, peNumber, organisations })
						.then(({ data }) => {
							const { errors, status } = data;
							dispatch(
								setFSSExpressCompany(peNumber, {
									status: status ? status : past,
									errors,
								}),
							);
						})
						.catch((error) => {
							dispatch(
								setFSSExpressCompany(peNumber, {
									error: `Failed to ${action}`,
									status: originalStatus,
								}),
							);
						});
				}),
			);

			dispatch(openFS7ValidationModal(false));
			dispatch(loadingValidation(undefined, submit));
			return;
		}

		await validateTaxForm({ year, form: "fs7", credentials, test: !submit })
			.then((response) => {
				dispatch(validationResult(response.data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(
					`Error ${continuous} ${form.toUpperCase()}`,
					`Error ${action} ${form.toUpperCase()}`,
				);
			});
		dispatch(loadingValidation(undefined, submit));
	};
};

const getFSSCompanies = ({ type, year, advisor }) => {
	return async (dispatch, getState) => {
		await settingsRequest({
			method: "GET",
			path: `/fss/organisations`,
			query: { type, year, advisor },
		})
			.then(({ data }) => {
				dispatch(fssOrganisations(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting FSS Companies");
			});
	};
};

const savingCISDeductions = (status, id) => ({
	type: Types.FSSREPORT_SAVING_CIS_DEDUCTIONS,
	status,
	id,
});

const saveCISDeductions = (value) => {
	return async (dispatch, getState) => {
		const state = getState();
		const modalStatus = state.taxForms?.cisModal;

		const { month, year, type, id, org } = modalStatus;

		const body = {
			month,
			year,
			type,
			org,
			cisDeductionsThisMonth: parseFloat(value),
		};

		// console.debug({
		// 	method: "POST",
		// 	path: `/taxReport/update/${id}`,
		// 	body,
		// });
		// return;

		dispatch(savingCISDeductions(true, id));

		let arn;

		await settingsRequest({
			method: "POST",
			path: `/taxReport/update/p32`,
			body,
			org
		})
			.then(({ data }) => {
				NotificationManager.success("CIS Deductions Saved, Regenerating Reports", "Saving CIS Deductions");
				arn = data.executionArn;
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving CIS Deductions");
			});

		if (arn) {
			await checkExecutionStatus(arn)
				.then(() => {
					NotificationManager.success("Reports Regenerated", "Saving CIS Deductions");
				})
				.catch((e) => {
					NotificationManager.error("Error Regenerating Reports", "Saving CIS Deductions");
				});
		}

		dispatch(savingCISDeductions(false, id));
		dispatch(
			listFssReports({
				name: type,
				year: year,
			}),
		);
		dispatch(openCISModal());
	};
};

const Actions = {
	validateFS7,
	listFssReports,
	downloadFSSReport,
	showF3InPortal,
	toggleV2TaxReports,
	openRegenerateFormsModal,
	regenerateFSSReports,
	openEIDModal,
	verifyEIDCredentials,
	selectSubmissionForm,
	downloadEmployeeForm,
	openFS7ValidationModal,
	getFSSCompanies,
	updateSelectedCompanies,
	openCISModal,
	saveCISDeductions,
	openTaxFormImportModal,
	uploadTaxForm,
	clearImportResults,
	fssReportingUpdateSingle,
};

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions
